<template>
  <div>
    <el-row style="margin: 0 auto;">
      <el-col :span="22">
        <el-form ref="searchForm" :model="searchForm" style="display: flex;column-gap: 20px;">
          <el-form-item>
            <div>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                size="mini"
                class="w300"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item v-if="showMarket">
            <el-select
                v-model="searchForm.market_id"
                size="mini"
                value-key="market_id"
                placeholder="请选择"
                filterable
              >
              <el-option
                v-for="item in marketList"
                :key="item.market_id"
                :label="item.market_name"
                :value="item.market_id"
              />
            </el-select>
          </el-form-item>
        </el-form>  
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('1')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}每日业绩</div>
            <div id="qMain8" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道总销售情况(新单+补单)</div>

            <div id="qMain1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}各渠道订单人数(老客+新客)</div>

            <div id="qMain2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道新客进店数据(客资+进店)</div>

            <div id="qMain3" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道(新客)进店数+成交数对比</div>

            <div id="qMain6" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="0">
          <div class="chart-wrapper">
            <div class="table-title" >{{name}}各渠道总成交人数(老客+新客)</div>

            <div id="qMain5" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row>
          <el-col :span="24" class="table-container">
            <div class="chart-wrapper">
              <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客）</div>
              <el-table
                :data="newList"
                :default-sort = "{prop: 'proceeds_balance', order: 'descending'}"
                border
                size="small"
                :cell-style="$style.cellStyle"
                :row-class-name="tableRowClassName"
                :header-cell-style="$style.rowClass"
                >
                <el-table-column prop="name" label="来源" width="120"/>
                <el-table-column prop="proceeds_balance" label="渠道业绩" width="120" sortable/>

                <el-table-column label="渠道销售占比" width="150" sortable>   
                  <template slot-scope="{row}">
                    {{row.proceeds_rete}}%
                  </template>      
                </el-table-column>                  
                <el-table-column prop="gainCount" label="获客人数" width="120" sortable/>
                <el-table-column prop="bhGainCount" label="疤痕" sortable/>
                <el-table-column prop="ddGainCount" label="痘痘" sortable />
                <el-table-column prop="pfGainCount" label="皮肤" sortable />
                <el-table-column prop="enterCount" label="进店人数" width="120" sortable />
                <el-table-column prop="bhEnterCount" label="疤痕" sortable/>
                <el-table-column prop="ddEnterCount" label="痘痘" sortable />
                <el-table-column prop="pfEnterCount" label="皮肤" sortable />
                <el-table-column prop="cjCount" label="成交人数" width="120" sortable />
                <el-table-column prop="bhCjCount" label="疤痕" sortable/>
                <el-table-column prop="ddCjCount" label="痘痘" sortable />
                <el-table-column prop="pfCjCount" label="皮肤" sortable />
                <el-table-column label="成交转化率" width="150" sortable>
                  <template slot-scope="{row}">
                    {{row.cj_rate}}%
                  </template>        
                </el-table-column>     
              </el-table>
            </div>
          </el-col>
      </el-row>
    </div>
    
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title">{{name}}各渠道顾客成交情况(老客+新客)</div>

            <div id="qMain7" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}各渠道数据表（新客+老客）</div>
            <el-table
              :data="allList"
              border
              size="small"
              :default-sort = "{prop: 'perform', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="来源" width="150"/>
              <el-table-column prop="perform" label="渠道业绩" sortable/>
              <el-table-column label="渠道销售占比" sortable>   
                <template slot-scope="{row}">
                  {{row.proceeds_rete}}%
                </template>      
              </el-table-column>     
              <el-table-column prop="cjCount" label="订单人数" sortable/>
              <el-table-column prop="bhCjCount" label="疤痕" sortable/>
              <el-table-column prop="ddCjCount" label="痘痘" sortable />
              <el-table-column prop="pfCjCount" label="皮肤" sortable/>
              <el-table-column prop="order_avg_price" label="客单价" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务销售表</div>
            <el-table
              :data="serviceList"
              height="600"
              size="small"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="150"/>
              <el-table-column prop="pay_amount" label="销售本金" align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金" align="center" sortable />
              <el-table-column prop="num" label="销售数量" align="center" sortable />
              <el-table-column prop="cj_num" label="成交人数" align="center" sortable/>
              <el-table-column prop="service_num" label="次数" align="center" sortable />
              <el-table-column prop="once_avg_price" label="单次均价"  width="120" align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}商品销售表</div>
            <el-table
              :data="goodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}"
              >
              <el-table-column prop="name" label="产品名称"  width="220"/>
              <el-table-column prop="pay_amount" label="销售本金"  align="center"  sortable />
              <el-table-column prop="gift_amount" label="销售赠金"  align="center"  sortable />
              <el-table-column prop="num" label="销售数量"  align="center"  sortable/>
              <el-table-column prop="cj_num" label="成交人数"   align="center" sortable />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}核销业绩</div>
            <div id="nMain1" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理人数</div>
            <div id="nMain2" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩与消耗额分析</div>
            <div id="nMain3" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩与赠金分析</div>
            <div id="nMain4" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
      <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店新单补单业绩</div>
            <div id="nMain5" class="chart-content" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店护理量/人头数/护理金额分析</div>
            <div id="nMain6" class="chart-content" />
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}服务核销数据</div>
            <div id="nMain7" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">  
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}产品出库明细</div>
            <div id="nMain8" class="chart-content" />          
          </div>
        </el-col>
      </el-row>        
    </div>
    <div class="charts-container">
      <el-row :gutter="20">
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom:3%;">{{name}}服务消耗表</div>
            <el-table
              :data="realServiceList"
              height="600"
              size="small"
              :default-sort = "{prop:'consume_count', order: 'descending'}"
              :row-class-name="tableRowClassName"
              >
              <el-table-column prop="name" label="服务名称" width="180"/>
              <el-table-column prop="consume_bj" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="consume_count" label="核销数量" align="center" sortable />
              <el-table-column prop="serve_num" label="护理人数" align="center" sortable />
              <el-table-column prop="once_serve_amount" label="单次护理金额"   align="center" sortable/>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 3%;">{{name}}产品出库表</div>
            <el-table
              :data="realGoodsList"
              height="600"
              size="small"
              :row-class-name="tableRowClassName"
              :default-sort = "{prop: 'pay_amount', order: 'descending'}">
              <el-table-column prop="name" label="产品名称" width="220"/>
              <el-table-column prop="pay_amount" label="核销金额（本金）" align="center"  sortable />
              <el-table-column prop="num" label="核销数量" align="center" sortable />
              <el-table-column prop="cj_num" label="人数" align="center" sortable />
              <el-table-column prop="once_amount" label="单件金额"  align="center" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}门店业绩表</div>
              <!-- show-summary  -->
            <el-table
              :data="shopTableData"
              border
              size="small"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="shopName" label="门店" width="120"/>
              <el-table-column prop="receipts" label="实际收款金额" sortable />
              <el-table-column prop="receipts_gift" label="收款赠金" width="110" sortable />
              <el-table-column prop="contribution_rete" label="门店贡献度" sortable>
                <template slot-scope="{row}"> 
                  {{row.contribution_rete}}%
                </template>    
              </el-table-column>             
              <el-table-column prop="xd_perform" label="新单业绩"  width="110" sortable/>
              <el-table-column prop="bd_perform" label="补单业绩" width="110"  sortable/>
             <el-table-column prop="consume_amount" label="品项消耗金额" sortable/>
              <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
              <el-table-column prop="transfer_amount" label="转诊消耗金额" sortable/>
              <el-table-column prop="abnormal_consume_amount" label="异常消耗"  width="110" sortable/>
              <el-table-column prop="consume_sum_amount" label="消耗总额" width="110" sortable/>
              
              <!-- <el-table-column prop="consume_amount" label="品项消耗金额" sortable/> -->
              <!-- <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
              <el-table-column prop="consume_sum_amount" label="消耗总额" sortable/> -->
              <el-table-column prop="amount_care_num" label="护理人数" width="110" sortable/>
              <el-table-column prop="num_care" label="护理量" width="90" sortable/>
              <el-table-column prop="consume_avg" label="单次护理金额（本金）" width="120" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="charts-container">
      <el-row>
        <el-col :span="24" class="table-container">
          <div class="chart-wrapper">
            <div class="table-title" style="margin-bottom: 2%;">{{name}}护理师业绩表</div>
            <el-table
              :data="bodyTableData"
              border
              size="small"
              height="500"
              :default-sort = "{prop: 'receipts', order: 'descending'}"
              :cell-style="$style.cellStyle"
              :row-class-name="tableRowClassName"
              :header-cell-style="$style.rowClass"
              >
              <el-table-column prop="name" label="护理师" width="120"/>
              <el-table-column prop="shop_name" label="所属门店" width="120"/>
              <el-table-column prop="receipts" label="实际收款金额" sortable />
              <el-table-column prop="receipts_gift" label="收款赠金" sortable />
              <el-table-column prop="contribution_rete" label="护理师贡献度" sortable>
                <template slot-scope="{row}"> 
                  {{row.contribution_rete}}%
                </template>    
              </el-table-column>             
              <el-table-column prop="xd_perform" label="新单业绩"  sortable/>
              <el-table-column prop="bd_perform" label="补单业绩"  sortable/>
              <!-- <el-table-column prop="consume_amount" label="消耗金额" sortable/> -->
              <el-table-column prop="consume_amount" label="品项消耗金额" sortable/>
              <el-table-column prop="goods_consume_amount" label="商品出库金额" sortable/>
              <el-table-column prop="transfer_amount" label="转诊消耗金额" sortable/>
              <el-table-column prop="abnormal_consume_amount" label="异常消耗" sortable/>
              <el-table-column prop="consume_sum_amount" label="消耗总额" sortable/>
              <el-table-column prop="amount_care_num" label="护理人数" sortable/>
              <el-table-column prop="num_care" label="护理量"  sortable/>
              <el-table-column prop="consume_avg" label="单次护理金额（本金）" sortable/>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { isShowMarketSearch,getMarket,getChannelEnterCustomer,goodsTop,getChannelData,serviceTop,getLookShop,getPersonChannel,marketShopPerform,realServiceTop,shopEverydayPerform} from '@/api/sys'
import { mapGetters } from "vuex";
class Search {
  date = [];
  market_id = '';

}

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
  },
    watch: {
    // 监听 tabIndex 变化，触发刷新
    tabIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList(); // 调用数据加载方法
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
     const that = this; 
    return {
      searchForm: new Search(),
      pickerOptions: {
        // 选择器范围：当前时间往前推两个月到当前时间
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            that.searchForm.date[0] = minDate.getTime(); 
          }
          if (maxDate) {
            that.searchForm.date[1] = maxDate.getTime(); 
          }
        },
        disabledDate: (time) => {
          console.log(time,"time")
          const year = time.getFullYear();
          if (year <= 2024) {
            return true;
          }
          const currentTime = time.getTime();
          const now = Date.now(); 
          console.log(that.searchForm.date[0],"that.searchForm.date[0]")
          if (that.searchForm.date[0]) {
            const startDate = new Date(that.searchForm.date[0]);
            const twoMonthsLater = new Date(startDate);
            twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
            const twoMonthsEarlier = new Date(startDate);
            twoMonthsEarlier.setMonth(twoMonthsEarlier.getMonth() - 2);
            return currentTime < twoMonthsEarlier || currentTime > twoMonthsLater || currentTime > now;
          }
        }
        
      },
      name:'',
      cjNum:0,
      cjAmount:0,
      showMarket:false,
      marketList:[],
      qList1:[],
      qList2:[],
      newList:[],
      allList:[],
      goodsList:[],
      serviceList:[],
      realServiceList:[],
      realGoodsList:[],
      qChart1: null,
      qChart2: null,
      qChart3: null,
      qChart4: null,
      qChart5: null,
      qChart6: null,
      qChart7: null,
      qChart8: null,
      list:[],
      shopTableData:[],
      bodyTableData:[],
      moneyList:[],
      hlNum:0,
      skAmount:0,
      nChart1: null,
      nChart2: null,
      nChart3: null,
      nChart4: null,
      nChart5: null,
      nChart6: null,
      nChart7: null,
      nChart8: null,
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
      // this.searchForm.date = this.generateDefaultThreeMonths();
      console.log(this.searchForm.date)
      this.getList();
      window.addEventListener('resize', this.handleResize);
    });
  },
  
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
    // 销毁图表实例
    if (this.qChart1) this.qChart1.dispose();
    if (this.qChart2) this.qChart2.dispose();
    if (this.qChart3) this.qChart3.dispose();
    if (this.qChart4) this.qChart4.dispose();
    if (this.qChart5) this.qChart5.dispose();
    if (this.qChart6) this.qChart6.dispose();
    if (this.qChart7) this.qChart7.dispose();
  },
  
  methods: {
    // generateDefaultThreeMonths() {
    // const now = new Date();
    //   const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    //   const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    //   const format = (date) => {
    //     return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    //   };
    //   return [format(monthStart), format(monthEnd)];
    // },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {  
        return {
          rowspan: row.maxnum,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    changeTab(index){
      // this.tabIndex = index
    },
    // 初始化图表实例
    initCharts() {
      const qMain1Dom = document.getElementById('qMain1');
      const qMain2Dom = document.getElementById('qMain2');
      const qMain3Dom = document.getElementById('qMain3');
      // const main44Dom = document.getElementById('main44');
      const qMain5Dom = document.getElementById('qMain5');
      const qMain6Dom = document.getElementById('qMain6');
      const qMain7Dom = document.getElementById('qMain7');
      const qMain8Dom = document.getElementById('qMain8');

      const nMain1Dom = document.getElementById('nMain1');
      const nMain2Dom = document.getElementById('nMain2');
      const nMain3Dom = document.getElementById('nMain3');
      const nMain4Dom = document.getElementById('nMain4');
      const nMain5Dom = document.getElementById('nMain5');
      const nMain6Dom = document.getElementById('nMain6');
      const nMain7Dom = document.getElementById('nMain7');
      const nMain8Dom = document.getElementById('nMain8');


      
      // 确保容器存在再初始化
      if (nMain1Dom) this.nChart1 = echarts.init(nMain1Dom);
      if (nMain2Dom) this.nChart2 = echarts.init(nMain2Dom);
      if (nMain3Dom) this.nChart3 = echarts.init(nMain3Dom);
      if (nMain4Dom) this.nChart4 = echarts.init(nMain4Dom);
      if (nMain5Dom) this.nChart5 = echarts.init(nMain5Dom);
      if (nMain6Dom) this.nChart6 = echarts.init(nMain6Dom);
      if (nMain7Dom) this.nChart7 = echarts.init(nMain7Dom);
      if (nMain8Dom) this.nChart8 = echarts.init(nMain8Dom);

      
      if (qMain1Dom) this.qChart1 = echarts.init(qMain1Dom);
      if (qMain2Dom) this.qChart2 = echarts.init(qMain2Dom);
      if (qMain3Dom) this.qChart3 = echarts.init(qMain3Dom);
      // if (main44Dom) this.qChart4 = echarts.init(main44Dom);
      if (qMain5Dom) this.qChart5 = echarts.init(qMain5Dom);
      if (qMain6Dom) this.qChart6 = echarts.init(qMain6Dom);
      if (qMain7Dom) this.qChart7 = echarts.init(qMain7Dom);
      if (qMain8Dom) this.qChart8 = echarts.init(qMain8Dom);


    },
    
    // 统一处理resize
    handleResize() {
      if (this.qChart1) this.qChart1.resize();
      if (this.qChart2) this.qChart2.resize();
      if (this.qChart3) this.qChart3.resize();
      // if (this.qChart4) this.qChart4.resize();
      if (this.qChart5) this.qChart5.resize();
      if (this.qChart6) this.qChart6.resize();
      if (this.qChart7) this.qChart7.resize();
      if (this.qChart8) this.qChart8.resize();
      
      if (this.nChart1) this.nChart1.resize();
      if (this.nChart2) this.nChart2.resize();
      if (this.nChart3) this.nChart3.resize();
      if (this.nChart4) this.nChart4.resize();
      if (this.nChart5) this.nChart5.resize();
      if (this.nChart6) this.nChart6.resize();
      if (this.nChart7) this.nChart7.resize();
      if (this.nChart8) this.nChart8.resize();

    },
    
    async getList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });

      try {
        const showMarketRes = await isShowMarketSearch();
        this.showMarket = showMarketRes.data || false;

        if (this.showMarket) {
          const marketRes = await getMarket();
          this.marketList = marketRes.data || []; // 空值处理：默认空数组
        } else {
          this.marketList = []; // 不显示市场时，清空列表避免旧数据干扰
        }

        if (this.showMarket) {
          this.searchForm.market_id = this.searchForm.market_id || 
            (this.marketList.length > 0 ? this.marketList[0].market_id : '');
        } else {
          this.searchForm.market_id = ''; // 不显示市场时，强制清空
        }

        const [startTime, endTime] = this.searchForm.date || []; // 解构安全处理
        const commonParams = {
          start_time: startTime || '',
          end_time: endTime || '',
          market_id: this.searchForm.market_id
        };
        
       getPersonChannel(commonParams)
      .then(res => {
        this.list = res.data || [];
        this.bodyTableData = this.list?.[0]?.list || []; // 保留原有的空值安全处理
      })
      .catch(err => {
        console.error("getPersonChannel 接口请求失败：", err);
        // this.$message.warning("个人渠道数据加载失败，不影响其他数据展示");
      });

        const requestPromises = [
          marketShopPerform(commonParams).then(res => {
            this.shopTableData = res.data?.[0]?.list || []; // 可选链+默认空数组
            const lastItem = this.shopTableData[this.shopTableData.length - 1] || {}; // 避免空数组访问报错
            this.skAmount = lastItem.consume_amount || 0;
            this.cjAmount = lastItem.perform_sum || 0;
            this.hlNum = lastItem.amount_care_num || 0;
            this.echarts3(this.shopTableData.slice(0, -1));
          }),

          goodsTop(commonParams).then(res => {
            this.goodsList = res.data || [];
            this.realGoodsList = this.goodsList;
            this.echartsRealGoods(this.realGoodsList.length ? this.realGoodsList.slice(0, -1) : []);
          }),

          serviceTop(commonParams).then(res => {
            this.serviceList = res.data || [];
          }),

          realServiceTop(commonParams).then(res => {
            this.realServiceList = res.data?.[0]?.list || [];
            this.echartsRealService(this.realServiceList.length ? this.realServiceList.slice(0, -1) : []);
          }),

          getChannelEnterCustomer(commonParams).then(res => {
            this.qList = res.data || [];
            this.newList = this.qList?.[0]?.list || [];
            this.name = this.qList?.[0]?.market_name || '';
            this.echarts1(this.newList.length ? this.newList.slice(0, -1) : []);
          }),

          getChannelData(commonParams).then(res => {
            this.qList2 = res.data || [];
            this.allList = this.qList2?.[0]?.list || [];
            const lastItem = this.allList[this.allList.length - 1] || {}; // 避免空数组访问报错
            // this.cjAmount = lastItem.proceeds_balance || 0;
            this.cjNum = lastItem.cjCount || 0;
            this.echarts2(this.allList.length ? this.allList.slice(0, -1) : []);
          }),

          shopEverydayPerform(commonParams).then(res => {
            this.moneyList = res.data?.list || []; // 安全处理
            this.echartsEveDay(this.moneyList);
          }),

        ];

        await Promise.all(requestPromises);

      } catch (err) {
        console.error("接口请求出错：", err);
        this.$message.error("数据加载失败，请重试");
      } finally {
        loading.close();
        this.$nextTick(() => {
          this.handleResize();
        });
      }
    },

    echartsEveDay(jine){
      if (!this.qChart8) return; 
      const nOption8 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              result += `${item.seriesName}: ${item.value}万元<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['业绩'], 
          selectedMode: 'single',
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        dataZoom: [
           {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0,
          }
        ],
         
        xAxis: {
          type: 'category',
          data: jine.map(item => item.date),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '金额（万元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}万元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '业绩',
            type: 'line',
            smooth: true,
            data: jine.map(item => (item.perform / 10000).toFixed(2)),
            barWidth: '40%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(243, 198, 105, 0.6)' },
                  { offset: 1, color: 'rgba(228, 145, 25, 0.1)' } 
                ]
              )
            },
            lineStyle: {
              width: 3,
              color: '#E49119'
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '万元'
            }
          }
        ]
      };
      this.qChart8.setOption(nOption8);
    },
    echartsRealGoods(jine){
      if (!this.nChart8) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.pay_amount) - Number(a.pay_amount);
      });
       
      const nOption8 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('数量') ? '个' : 
                          item.seriesName.includes('核销额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销额', '数量', '人数'], // 图例顺序（与系列name匹配即可）
          selected: {
            '核销额': true,    // 默认隐藏
            '数量': false, // 默认隐藏
            '人数': false        // 默认显示
          },
          selectedMode: 'single', // 核心配置：开启图例单选模式（每次仅一个选中）
          textStyle: {}
        },
         dataZoom: [
           {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销额', // 与legend.data[0]匹配
            type: 'bar',
            data: sortedJine.map(item => item.pay_amount),
            barWidth: '40%', // 单选模式下仅显示一列，加宽柱子更美观（原20%→40%）
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          },
          {
            name: '数量', // 与legend.data[1]匹配
            type: 'bar',
            data: sortedJine.map(item => item.num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '个'
            }
          },
          {
            name: '人数', // 与legend.data[2]匹配
            type: 'bar',
            data: sortedJine.map(item => item.cj_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          }
        ]
      };
      this.nChart8.setOption(nOption8);
    },
    echartsRealService(jine){
      if (!this.nChart7) return;
      const sortedJine = [...jine].sort((a, b) => {
        return Number(b.consume_count) - Number(a.consume_count);
      });
      const nOption7 = {
        tooltip: {
          trigger: 'axis',
          textStyle: { align: 'left' },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['核销数', '护理人数', '单次核销金额'], // 图例顺序（与系列name匹配即可）
          selected: {
            '护理人数': false,    // 默认隐藏
            '单次核销金额': false, // 默认隐藏
            '核销数': true        // 默认显示
          },
          selectedMode: 'single', // 核心配置：开启图例单选模式（每次仅一个选中）
          textStyle: {}
        },
        
         dataZoom: [
          {
            type: 'slider',
            show: jine.length > 10, 
            xAxisIndex: 0,
            start: 0,
            end: (30 / jine.length) * 100, 
            filterMode: 'filter', 
            bottom: 0
          }
        ],
        grid: {
          left: '3%',
          right: '3%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: sortedJine.map(item => item.name),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0, color: '#000', fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 0, 0, 5] },
            axisLine: { lineStyle: { color: '#3468E9' } },
            axisLabel: { formatter: '{value}', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: { color: '#666', fontSize: 12, padding: [0, 5, 0, 0] },
            axisLine: { show: false },
            axisLabel: { formatter: '{value}元', color: '#666', fontSize: 12 },
            splitLine: { lineStyle: { color: '#CDD3E2' }}
          }
        ],
        series: [
          {
            name: '核销数', // 与legend.data[0]匹配
            type: 'bar',
            data: sortedJine.map(item => item.consume_count),
            barWidth: '40%', // 单选模式下仅显示一列，加宽柱子更美观（原20%→40%）
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '次'
            }
          },
          {
            name: '护理人数', // 与legend.data[1]匹配
            type: 'bar',
            data: sortedJine.map(item => item.serve_num),
            barWidth: '40%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '人'
            }
          },     
          {
            name: '单次核销金额', // 与legend.data[2]匹配
            type: 'bar',
            data: sortedJine.map(item => item.once_serve_amount),
            barWidth: '40%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              formatter: params => params.value === 0 ? '' : params.value + '元'
            }
          }
        ]
      };
      this.nChart7.setOption(nOption7);
    },
    // 新客+老客
    echarts2(jine) {
      if (!this.qChart1) return;
      if (!this.qChart2) return;
      if (!this.qChart7) return;
      const baseColors = [
          '#2767FC', '#3491FA', '#4DA6FF', '#69B1FF', // 蓝色系（浅→深）
          '#E49119', '#F3C669', '#FFD787', '#FFE8B3', // 橙色系
          '#36CFC9', '#5AD8A6', '#8AE29E', '#B7F0B3', // 绿色系
          '#D93F30', '#F56C6C', '#FF9E99', '#FFC7C2', // 红色系
          '#722ED1', '#9370DB', '#B39DDB', '#D8C9F0', // 紫色系
          '#86909C', '#A8B0BD', '#C9CDD4', '#E5E6EB'  // 灰色系
      ];
      const professionalColors1 = ['#6A98E4', '#2767FC', '#85D4EE', '#EB5B73','#FFA06C','#376473','#31c5e9'];
      const professionalColors2 = ['#9FE6B8', '#32C5E9', '#2767FC', '#9D96F5','#E062AE','#FFA06C','#FEDB65'];

      const qOption1 = {
        color: baseColors,
        title: {
          text: this.cjAmount,
          textStyle: {
            fontSize: 32,
            color: '#2767FC',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}元 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.proceeds_balance !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false // 图例隐藏，不影响核心功能
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: function(params) {
                // 双重保险：即使有漏网的0值，也隐藏标签
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}元 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            // 关键：过滤掉proceeds_balance为0的数据，不渲染对应的扇区
            data: jine
              .filter(item => item.proceeds_balance !== 0) // 只保留非0值数据
              .map(item => ({
                name: item.name,
                value: item.proceeds_balance
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      const qOption2 = {
        color: baseColors,
        title: {
          text: this.cjNum,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC', 
            fontWeight: 'bold' 
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          // 双重保险：0值不显示tooltip
          formatter: function(params) {
            return params.value === 0 ? '' : `${params.name}: ${params.value}人 (${params.percent}%)`;
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: jine.filter(item => item.cjCount !== 0).map(item => item.name),
          type: 'scroll',
          scrollDataIndex: 0,
          pageButtonPosition: 'end',
          pageIconSize: 10,
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: function(params) {
                if (params.value === 0) {
                  return '';
                }
                return `${params.name}: ${params.value}人 \n(${params.percent}%)`;
              },
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine.filter(item => item.cjCount !== 0).map(item => ({
                name: item.name,
                value: item.cjCount // 人数数据（确保字段正确）
              })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      const qOption7 = {
        title: {
          show:false,
          text: `${this.name}各渠道顾客成交情况(新客+老客)`,
          left: 'center',
          textStyle: { 
            fontSize: 24,
            background:'red'

          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {  }
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name), // 渠道名称数组
          axisLine: { lineStyle: {} },
          axisLabel: { 
            interval: 0  // 强制显示所有标签（配合滚动）
          },
          scrollbar: {
            show: true,  // 开启滚动条
            height: 8,   // 滚动条高度（单位：px）
            bottom: 5,   // 滚动条距离底部的距离（避免与坐标轴重叠）
            backgroundColor: 'transparent', // 背景透明
            handleColor: '#2767FC',         // 滚动条滑块颜色
            handleSize: 15,                 // 滑块大小
            showDataShadow: false,          // 关闭数据阴影
            showDetail: false               // 不显示详细信息
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            minInterval: 1,
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' }, // 橙色系区分
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          }
        ]
      };
      this.qChart1.setOption(qOption1);
      this.qChart2.setOption(qOption2);
      this.qChart7.setOption(qOption7);
    },
    echarts1(jine) {
      if (!this.qChart3) return;
      // if (!this.qChart4) return;
      if (!this.qChart5) return;
      if (!this.qChart6) return;
     
      const qOption3 = {
        title: {
          show:false,
          text: `${this.name}各渠道新客进店数据(客资+进店)`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left:'center',
          top: '4%',
          data: ['获客数', '成交数', '进店数'],
          textStyle: {  }
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: { } },
          // axisLabel: { rotate: 45, interval: 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '获客数',
            type: 'bar',
            data: jine.map(item => item.gainCount), // 明确字段
            barWidth: '20%',
            barCategoryGap: '30%', // 增大组间间距
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9 ' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
      
          {
            name: '成交数',
            type: 'line',
            data: jine.map(item => item.cjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#78DF69' }, // 橙色系区分
                { offset: 1, color: '#78DF69' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },    
          {
            name: '进店数',
            type: 'bar',
            data: jine.map(item => item.enterCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADBEDB' },
                { offset: 1, color: '#ADBEDB' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
        ]
      };
      const qOption4 = {
        title: {
          show:false,
          text: `${this.name}各渠道进店数据`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          top: '4%',
          right: 'center', // 缩小右侧间距，避免遮挡
          data: ['获客数', '进店数'],
          textStyle: {}
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name),
          axisLine: { lineStyle: {  } },
          // axisLabel: { rotate: 45, interval: 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: { } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '获客数',
            type: 'bar',
            data: jine.map(item => item.gainCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
            }
          },
          {
            name: '进店数',
            type: 'bar',
            data: jine.map(item => item.enterCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
            }
          }
        ]
      };
      const qOption5 = {
        title: {
          show:false,
          text: `${this.name}各渠道(新客)成交数`,
          left: 'center',
          textStyle: { 
            fontSize: 24

          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '4%',
          data: ['疤痕', '痘痘', '皮肤'],
          textStyle: {  }
        },
        grid: {
          left: '1%',
          right: '1%', // 为图例腾出空间
          bottom: '1%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.name), // 渠道名称数组
          axisLine: { lineStyle: {} },
          axisLabel: { 
            // rotate: 45,  // 标签旋转，避免重叠
            interval: 0  // 强制显示所有标签（配合滚动）
          },
          // 核心：添加滚动条配置
          scrollbar: {
            show: true,  // 开启滚动条
            height: 8,   // 滚动条高度（单位：px）
            bottom: 5,   // 滚动条距离底部的距离（避免与坐标轴重叠）
            backgroundColor: 'transparent', // 背景透明
            handleColor: '#2767FC',         // 滚动条滑块颜色
            handleSize: 15,                 // 滑块大小
            showDataShadow: false,          // 关闭数据阴影
            showDetail: false               // 不显示详细信息
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（人）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}人' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '疤痕',
            type: 'bar',
            stack : "堆叠",
            data: jine.map(item => item.bhCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '痘痘',
            type: 'bar',
            data: jine.map(item => item.ddCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' }, // 橙色系区分
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '皮肤',
            type: 'bar',
            data: jine.map(item => item.pfCjCount),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          }
        ]
      };
      const qOption6 ={
          title: {
            show:false,
            text: `${this.name}各渠道(新客)进店数与成交数对比`,
            left: 'center',
            textStyle: { fontSize: 24 }
          },
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
            },
            axisPointer: { type: 'shadow' },
            formatter: function(params) {
              let result = `${params[0].name}<br/>`;
              params.forEach(item => {
                const unit = item.seriesName.includes('转化率') ? '%' : '人';
                result += `${item.seriesName}: ${item.value}${unit}<br/>`;
              });
              return result;
            }
          },
          legend: {
            orient: 'horizontal',
            right: 'center',
            top: '4%',
            data: [
              '进店-疤痕','进店-痘痘','进店-皮肤',
              '成交-疤痕','成交-痘痘','成交-皮肤'
            ],
            textStyle: { fontSize: 12 },
            formatter: function(name) {
              return name === '\n' ? '' : (name.includes('成交') ? '成交：' : '进店：') + name.split('-')[1];
            }
          },
          grid: {
            left: '1%',
            right: '1%',
            bottom: '1%',
            top: '12%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: jine.map(item => item.name),
            axisLine: { lineStyle: {} },
            axisLabel: { 
              interval: 0  
            }
          },
          yAxis: [
            {
              type: 'value',
              name: '数量（人）',
              nameTextStyle: {},
              axisLine: { lineStyle: {} },
              axisLabel: { formatter: '{value}人' },
              splitLine: { lineStyle: { color: '#CDD3E2' } }
            }
          ],
          series: [
            {
              name: '进店-疤痕',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.bhEnterCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(81, 182, 246, 0.8)' }, // 浅天蓝（比成交蓝更亮）
                  { offset: 1, color: 'rgba(33, 150, 243, 0.8)' }  // 深天蓝（比成交蓝稍浅）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
               show:true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }

              }
            },
            {
              name: '进店-痘痘',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.ddEnterCount),
              barWidth: '25%',
              itemStyle: {
                // 对应成交-痘痘的蓝灰色系 → 更雅致的青灰色渐变（避免沉闷）
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#ADBEDB' },
                    { offset: 1, color: '#ADBEDB' } // 深青灰（比成交蓝灰更暖）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }

              }
            },
            {
              name: '进店-皮肤',
              type: 'bar',
              stack: '进店组',
              data: jine.map(item => item.pfEnterCount),
              barWidth: '25%',
              itemStyle: {
                // 对应成交-皮肤的橙色系 → 更温暖的琥珀色渐变（不刺眼，显柔和）
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(252, 211, 77, 0.8)' }, // 浅琥珀（比成交橙更亮）
                  { offset: 1, color: 'rgba(245, 158, 11, 0.8)' }  // 深琥珀（比成交橙稍浅）
                ]),
                borderRadius: [0, 0, 4, 4]
              },
              label: {
               show: true,
                fontSize: 12,
                color: 'white',
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-疤痕',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.bhCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#E91E63' },
                  { offset: 1, color: '#E91E63' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white'  ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-痘痘',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.ddCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2196F3' },
                  { offset: 1, color: '#2196F3' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white',
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            },
            {
              name: '成交-皮肤',
              type: 'bar',
              stack: '成交组',
              data: jine.map(item => item.pfCjCount),
              barWidth: '25%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#00BCD4' },
                  { offset: 1, color: '#00BCD4' }
                ]),
                borderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                fontSize: 12,
                color: 'white' ,
                formatter: function(params) {
                  return params.value === 0 ? '' : params.value + '人';
                }
              }
            }
          ]
      };

      this.qChart3.setOption(qOption3);
      // this.qChart4.setOption(option4);
      this.qChart5.setOption(qOption5);
      this.qChart6.setOption(qOption6);



    },
    echarts3(jine) {
      if (!this.nChart1) return;
      if (!this.nChart2) return;
      if (!this.nChart3) return;
      if (!this.nChart4) return;
      if (!this.nChart5) return;
      if (!this.nChart6) return;

      const professionalColors1 = ['#6A98E4', '#2767FC', '#85D4EE', '#EB5B73','#FFA06C','#376473','#31c5e9'];
      const professionalColors2 = ['#9FE6B8', '#32C5E9', '#2767FC', '#9D96F5','#E062AE','#FFA06C','#FEDB65'];

      const nOption1 = {
        // color: professionalColors1,
        title: {
         text: this.skAmount,
          textStyle: {
            fontSize: 32, 
            color: '#2767FC ', 
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}元 ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{b}: {c}元 \n({d}%)',
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)', 
              padding: [8, 10], 
              borderRadius: 4, 
              borderWidth: 1 
            },
            data: jine.map(item => ({
              name: item.shopName, // 渠道名称（与图例对应）
              value: item.consume_amount // 成交金额（用于计算占比）
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }                 
          } 
        ]
      };
      const nOption2 = {
        color: professionalColors2,
        title: {
         text: this.hlNum,
          textStyle: {
            fontSize: 32,
            color: '#2767FC ',
            fontWeight: 'bold'
          },
          left: 'center',
          top: 'center', 
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)' // 保持人数单位，正确
        },
        legend: {
          show: false

        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'], // 内半径40%（控制中心区域大小）
            labelLine: {
              length: 30
            },
            label: {
              formatter: '{b}: {c}人 \n({d}%)',
              
              fontWeight: 'bold',
              fontSize: 14,
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: [8, 10],
              borderRadius: 4,
              borderWidth: 1
            },
            data: jine.map(item => ({
              name: item.shopName,
              value: item.amount_care_num // 确保item.amount是人数数据
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
      };
      const nOption3 = {
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理师贡献度') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '门店业绩','门店消耗额'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name:'门店业绩',
            type: 'bar',
            data: jine.map(item => item.perform_sum),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '门店消耗额',
            type: 'bar',
            data: jine.map(item => item.consume_amount),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号       
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };

      const nOption4 ={
        title: {
          show:false,
          text: `${this.name}护理师收款本金与赠金分析`,
          left: 'center',
          textStyle: { 
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('赠送比例') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '0%',
          data: [ '业绩','收款赠金','赠送比例'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%', // 为右侧Y轴腾出更多空间
          bottom: '1%', // 增加底部空间防止标签截断
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: 'red' 
              } 
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '比例',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: true, // 显示第二条Y轴线以便观察
              lineStyle: {
                color: 'none' // 与贡献度颜色呼应
              }
            },
            axisLabel: {  
              formatter: '{value}%',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            },
          }
        ],
        series: [
          {
            name: '业绩',
            type: 'bar',
            yAxisIndex: 0, // 关键修复：指定使用第二个Y轴
            data: jine.map(item => item.perform_sum),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#3468E9' },
                { offset: 0, color: '#79A7FE' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元' 
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '收款赠金',
            type: 'bar',
            yAxisIndex: 0, 
            data: jine.map(item => item.receipts_gift),
            barWidth: '20%',
            barCategoryGap: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',      
              fontSize: 14,
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          },
          {
            name: '赠送比例',
            type: 'line',
            yAxisIndex: 1, 
            data: jine.map(item => {
              const gift = Number(item.receipts_gift) || 0; // 转换为数值，默认0
              const total = Number(item.receipts) || 0;
              return total === 0 ? 0 : Number(((gift / total) * 100).toFixed(2));
            }),
            symbol: 'circle', // 添加标记点
            symbolSize: 8,
            lineStyle: {
              color: '#78DF69',
              width: 2
            },
            itemStyle: {
              color: '#78DF69',
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}%' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '%';
              }
            }
          }
        ]
      };
      const nOption5 = {
        title: {
          show:false,
          text: `${this.name}护理师新单补单业绩`,
          left: 'center',
          textStyle: { 
            fontSize: 24

          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('转化率') ? '%' : '元';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center', // 缩小右侧间距，避免遮挡
          top: '0%',
          data: ['新单业绩', '补单业绩'],
          textStyle: {  }
        },
        grid: {
          left: '5%',
          right: '5%', // 为图例腾出空间
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: { } },
          axisLabel: { rotate: 45, interval: 0,color: '#000',fontSize: 12 }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量（元）',
            nameTextStyle: {},
            axisLine: { lineStyle: {  } },
            axisLabel: {  formatter: '{value}元' },
            splitLine: { lineStyle: { color: '#CDD3E2' } }
          }
        ],
        series: [
          {
            name: '新单业绩',
            type: 'bar',
            data: jine.map(item => item.xd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          },
          {
            name: '补单业绩',
            type: 'bar',
            data: jine.map(item => item.bd_perform),
            barWidth: '20%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' }, // 橙色系区分
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top', // 水平条形图的“上边”对应右侧
              fontSize: 14,
              // formatter: '{c}元' // 显示百分比符号
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }

            }
          }
        ]
      };
      const nOption6 = {
        title: {
          show:false,
          text: `${this.name}护理师护理量/人头数/护理金额分析`,
          left: 'center',
          textStyle: {
            fontSize: 24
          }
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'  // 核心属性：强制内容左侧对齐（默认是 'center' 或自适应）
          },
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            let result = `${params[0].name}<br/>`;
            params.forEach(item => {
              const unit = item.seriesName.includes('护理量') ? '次' : 
                          item.seriesName.includes('金额') ? '元' : '人';
              result += `${item.seriesName}: ${item.value}${unit}<br/>`;
            });
            return result;
          }
        },
        legend: {
          orient: 'horizontal',
          right: 'center',
          top: '0%',
          data: ['护理人数', '护理量', '单次护理金额（本金）'],
          textStyle: {}
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '1%', // 增加底部空间，避免滑动条遮挡
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: jine.map(item => item.shopName),
          axisLine: { lineStyle: {} },
          axisLabel: { 
           rotate: 45, interval: 0,color: '#000',fontSize: 12
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '数量',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 0, 0, 5]
            },
            axisLine: { 
              lineStyle: { 
                color: '#3468E9'
              } 
            },
            axisLabel: {  
              formatter: '{value}',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              lineStyle: { 
                color: '#CDD3E2' 
              } 
            }
          },
          {
            type: 'value',
            name: '金额（元）',
            nameTextStyle: {
              color: '#666',
              fontSize: 12,
              padding: [0, 5, 0, 0]
            },
            axisLine: { 
              show: false
            },
            axisLabel: {  
              formatter: '{value}元',
              color: '#666',
              fontSize: 12
            },
            splitLine: { 
              show: false 
            }
          }
        ],
        series: [
          {
            name: '护理人数',
            type: 'bar',
            data: jine.map(item => item.amount_care_num),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#79A7FE' },
                { offset: 1, color: '#3468E9' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}人'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '人';
              }
            }
          },
          {
            name: '护理量',
            type: 'bar',
            data: jine.map(item => item.num_care),
            barWidth: '20%',
            yAxisIndex: 0,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#B6C2DC' },
                { offset: 1, color: '#4C5F8D' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}次'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '次';
              }
            }
          },
          {
            name: '单次护理金额（本金）',
            type: 'bar',
            data: jine.map(item => item.consume_avg),
            barWidth: '20%',
            yAxisIndex: 1,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F3C669' },
                { offset: 1, color: '#E49119' }
              ]),
              borderRadius: 4
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 14,
              // formatter: '{c}元'
              formatter: function(params) {
                return params.value === 0 ? '' : params.value + '元';
              }
            }
          }
        ]
      };

      this.nChart1.setOption(nOption1);
      this.nChart2.setOption(nOption2);
      this.nChart3.setOption(nOption3);
      this.nChart4.setOption(nOption4);
      this.nChart5.setOption(nOption5);
      this.nChart6.setOption(nOption6);


    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex%2 == 0) {
        return 'ou-row';

      } else{
        return 'ji-row';

      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep  .el-table__footer-wrapper .el-table__cell {
  text-align: center !important;
  font-weight: bold !important; 
}
::v-deep .el-table tr.ou-row {
  background-color: #EEF6FF;
}
::v-deep .el-table tr.ji-row {
  background-color: #D4E6F4;
}

 ::v-deep .el-table__cell {
  //  background: #EEF6FF !important;
   color: #2861C0 !important;
   color: #333333 !important;
   color: #2861C0 !important;

   font-weight: 600;
   font-size: 15px;
 }
  // ::v-deep .el-table__body {
  //   td:nth-child(1) { // 第2列
  //     color: #000000 !important;
  //   }
  // }

::v-deep .el-table__header .el-table__cell {
  background: #C2DBF9  !important; /* 与内容区背景统一 */
  color: #000000 !important;
}

::v-deep .el-table__row:hover > .el-table__cell {
  // background: #C2DBF9  !important; /* 略浅的hover背景，保持一致性 */
}
.flex{
  color: #333;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    font-size: 1.2rem;
    padding: 1.5rem 3rem;
    border: 1px solid #EDF2FF;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 0.5rem #EDF2FF;
    background-color: #EDF2FF;
    overflow: hidden;
    text-align: center;
    span{
      display: block; 
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0.3rem;
    }
  }
}
/* 图表容器样式优化 */
.charts-container {
  margin: 20px 0;
 text-align: center;
  .table-title{
    display: inline-block; 
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    background: #79A7FE;
    // background: #C2DBF9;
  //  background: linear-gradient(270deg, #33bea7 0%, #60e0c5 50%, #88f0e1 100%);
    padding:1rem ;
    border-radius: 1rem;

  }
}

.chart-wrapper {
  width: 100%;
  box-sizing: border-box; /* 确保padding不会增加元素总宽度 */
  background: #EDF2FF;
  padding: 2%;
  box-sizing: border-box;
  border-radius: 3rem;

}

.chart-content {
  width: 100%;
  height: 540px; /* 固定高度，确保初始化时有明确尺寸 */
}
</style>
